// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
window.Rails = Rails
Rails.start()
import "@hotwired/turbo-rails"
import * as ActiveStorage from '@rails/activestorage'
ActiveStorage.start()

import * as bootstrap from 'bootstrap'
window.bootstrap = bootstrap

import $ from 'jquery'
global.$ = $
window.$ = $
window.jquery = $
window.jQuery = $

import 'cocoon-js-vanilla'
import 'helpers/data_confirm_modal'
import '../stylesheets/application.scss'

function requireAll(context) {
  context.keys().forEach(context)
}
requireAll(require.context('custom/', true, /\.js$/))
